<script lang="ts">
  import { Accordion, ScrollArea, Tabs } from 'bits-ui';

  import type { TeoHelpSection } from '@/teoCore/TeoHelp';

  import HelpAccordionItem from './HelpAccordionItem.svelte';

  let { section }: { section: TeoHelpSection } = $props();
</script>

<Tabs.Content value={section.id} class="h-[384px] w-full">
  <ScrollArea.Root class="relative h-full overflow-hidden pb-2">
    <ScrollArea.Viewport class="h-full w-full">
      <Accordion.Root
        type="multiple"
        class="flex flex-col gap-4 p-6"
        value={section.content.filter((c) => c.selected).map((c) => c.id)}
      >
        {#each section.content as content (content.id)}
          <HelpAccordionItem {content} />
        {/each}
      </Accordion.Root>
    </ScrollArea.Viewport>
    <ScrollArea.Scrollbar
      orientation="vertical"
      class="data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out-0 data-[state=visible]:fade-in-0 flex w-2 touch-none select-none rounded-full p-px py-2 pr-1 transition-all duration-[30ms] hover:w-3 hover:bg-prim-H"
    >
      <ScrollArea.Thumb class="flex-1 rounded-lg bg-marker-change" />
    </ScrollArea.Scrollbar>
  </ScrollArea.Root>
</Tabs.Content>
